import { Button, Tooltip, Typography } from '@mui/material';

const colorClasses = {
  default: 'bg-healthera hover:bg-healthera-hover text-white',
  outlined: 'bg-white text-healthera border border-healthera',
  disabled: 'bg-grey-400 text-white',
};

export default function HealtheraButton(props) {
  const { classes = '', disabledMessage, ...attributes } = props;

  let color = colorClasses.default;
  if (attributes.disabled) color = colorClasses.disabled;
  if (attributes.variant) color = colorClasses.outlined;

  if (disabledMessage) {
    return (
      <Tooltip title={<Typography variant="body1">{disabledMessage}</Typography>}>
        <div>
          <Button
            variant="contained"
            className={`w-fit ${color} rounded font-500 ${classes}`}
            {...attributes}
          />
        </div>
      </Tooltip>
    );
  }

  return (
    <Button
      variant="contained"
      className={`w-fit ${color} rounded font-500 ${classes}`}
      {...attributes}
    />
  );
}
